import React from 'react';
import PageLayout from '@/components/layout/PageLayout';
import { Wizard } from '@/components/ui/navigation/Wizard';
import { useEmployeeCreate } from '@/hooks/employee/useEmployeeCreate';
import { CreateEmployeePersonalDataForm } from '@/components/features/employee/createEmployeePersonalDataForm';
import { CreateEmployeeContactDataForm } from '@/components/features/employee/createEmployeeContactDataForm';
import { CreateEmployeeAddressDataForm } from '@/components/features/employee/createEmployeeAddressDataForm';


export const EmployeeCreate: React.FC = () => {
  const {
    isLoading,
    setActiveTab,
    currentStepIndex,
    completedSteps,
    handleCancel,
    handleCreate,
    genderOptions,
    maritalStatusOptions,
    employmentStatusOptions,
    regionOptions,
    communeOptions,
    workRegionOptions,
    workCommuneOptions,
    creating,
    usernameSuffix,
    generatedUsername,
    syncAssistance,
    personalForm,
    contactForm,
    addressForm,
    handleNext,
    handlePrevious,
  } = useEmployeeCreate();

  const steps = [
    {
      id: 'personal',
      label: 'Datos personales',
      content: (
        <CreateEmployeePersonalDataForm
          personalForm={personalForm}
          genderOptions={genderOptions}
          maritalStatusOptions={maritalStatusOptions}
          employmentStatusOptions={employmentStatusOptions}
          usernameSuffix={usernameSuffix}
          generatedUsername={generatedUsername}
          syncAssistance={syncAssistance}
          onCancel={handleCancel}
          onNext={handleNext}
        />
      ),
    },
    {
      id: 'contact',
      label: 'Datos de contacto',
      content: (
        <CreateEmployeeContactDataForm
          contactForm={contactForm}
          onCancel={handleCancel}
          onNext={handleNext}
          onPrevious={handlePrevious}
        />
      ),
    },
    {
      id: 'address',
      label: 'Dirección',
      content: (
        <CreateEmployeeAddressDataForm
          addressForm={addressForm}
          regionOptions={regionOptions}
          communeOptions={communeOptions}
          workRegionOptions={workRegionOptions}
          workCommuneOptions={workCommuneOptions}
          onCancel={handleCancel}
          onCreate={handleCreate}
          creating={creating}
          onPrevious={handlePrevious}
        />
      ),
    },
  ];

  return (
    <PageLayout isLoading={isLoading}>
      <div className="flex flex-col gap-6" data-testid="employee-create-page">
        <Wizard
          steps={steps}
          currentStep={currentStepIndex}
          completedSteps={completedSteps}
          onStepChange={(stepIndex) => {
            const indexToTab: Record<number, 'personal' | 'contact' | 'address'> = {
              0: 'personal',
              1: 'contact',
              2: 'address',
            };
            setActiveTab(indexToTab[stepIndex]);
          }}
        />
      </div>
    </PageLayout>
  );
};

export default EmployeeCreate;
